var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class RadioButtons extends Component {
  change(value) {
    this.props.onChange(value);
  }

  checked(value) {
    return value === this.props.value;
  }

  renderLabel(opt) {
    if (this.props.renderLabel) {
      return this.props.renderLabel(opt);
    }

    const { optionsLabel } = this.props;
    return opt[optionsLabel];
  }

  render() {
    const { optionsValue, prefix, options } = this.props;

    return /*#__PURE__*/(
      _jsx("div", {}, void 0,
      options.map((option) => /*#__PURE__*/
      _jsx("div", { className: "radio" }, option[optionsValue], /*#__PURE__*/
      _jsx("label", { htmlFor: prefix + option[optionsValue] }, void 0, /*#__PURE__*/
      _jsx("input", {
        type: "radio",
        value: option[optionsValue],
        id: prefix + option[optionsValue],
        onChange: this.change.bind(this, option[optionsValue]),
        checked: this.checked(option[optionsValue]) }
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-name" }, void 0, this.renderLabel(option))
      )
      )
      )
      ));

  }
}

RadioButtons.defaultProps = {
  optionsLabel: 'label',
  optionsValue: 'value',
  prefix: '',
  renderLabel: undefined,
  value: null
};